import Button, { ButtonProps, ButtonPropsColorOverrides } from '@mui/material/Button'
import { OverridableStringUnion } from '@mui/types'
import { FC } from 'react'

export type C1ButtonColorType = OverridableStringUnion<
  'primary' | 'error' | 'info' | 'success' | 'inherit',
  ButtonPropsColorOverrides
>

type C1ButtonBaseProps = Omit<
  ButtonProps,
  'color' | 'size' | 'disableElevation' | 'disableFocusRipple' | 'variant'
> & {
  variant?: 'outlined' | 'text' | 'contained';
  color?: C1ButtonColorType;
};

// Contained variant cannot use 'info' color
export type ContainedButtonProps = {
  variant: 'contained';
  color?: Exclude<C1ButtonColorType, 'info'>;
}

// Outlined/Text variant can use any color
type OutlinedOrTextButtonProps = {
  variant?: 'outlined' | 'text';
  color?: C1ButtonColorType;
};

export type C1ButtonProps =
  & C1ButtonBaseProps
  & (ContainedButtonProps | OutlinedOrTextButtonProps)

export const C1Button: FC<C1ButtonProps> = (props) => <Button {...props} />
